// extracted by mini-css-extract-plugin
export var content = "_nb-1";
export var noScroll = "_nb-3";
export var paper = "_nb-0";
export var scrollable = "_nb-2";